// A background (daemon) agent turn's request_id: `daemon_<goal_id>`.
// Mirror of HARTOS core.chat_client.DAEMON_PREFIX / daemon_request_id, and of
// Nunba landing-page/src/constants/chatBubble.js (4941a4e8).
//
// HARTOS delivers a daemon turn's thinking and status to the person who owns
// the goal (crossbar_publish.trace_audience), so those envelopes arrive on the
// same com.hertzai.hevolve.chat.<userId> topic as the person's own turns. This
// id is the only field that tells the two apart. The web app has no floating
// window to show them in, so the chat drops them.
export const DAEMON_REQUEST_PREFIX = "daemon_";

// True for an envelope from a background agent turn, never the person's own.
export function isBackgroundRequest(requestId) {
  return (
    typeof requestId === "string" && requestId.startsWith(DAEMON_REQUEST_PREFIX)
  );
}
